import React, { useState } from 'react';
import { useCurrentLanguage, useTranslator } from 'tradera/lang/translate';
import dayjs from 'dayjs';
import { classNames } from 'tradera/utils/class-names';
import styles from './date-of-birth-input.module.scss';

type DateOfBirthInputProps = {
    onChange: (value: dayjs.Dayjs | null) => void;
    className: string;
};

export const DateOfBirthInput = ({
    onChange,
    className
}: DateOfBirthInputProps) => {
    const [day, setDay] = useState<string | undefined>(undefined);
    const [month, setMonth] = useState<string | undefined>(undefined);
    const [year, setYear] = useState<string | undefined>(undefined);
    const lang = useCurrentLanguage().language;
    const { t } = useTranslator();
    const onDayChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newDay = e.target.value;
        setDay(newDay);
        runOnChange(year, month, newDay);
    };
    const onMonthChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newMonth = e.target.value;
        setMonth(newMonth);
        runOnChange(year, newMonth, day);
    };
    const onYearChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newYear = e.target.value;
        setYear(newYear);
        runOnChange(newYear, month, day);
    };
    const runOnChange = (
        year: string | undefined,
        month: string | undefined,
        day: string | undefined
    ) => {
        const value =
            year && month && day ? dayjs([year, month, day].join('-')) : null;
        onChange(value);
    };
    const days = Array.from({ length: 31 }, (_, index) => 1 + index); // 1-31
    const months = Array.from({ length: 12 }, (_, index) => 1 + index); // 1-12
    const thisYear = new Date().getFullYear();
    const years = Array.from(
        { length: 85 },
        (_, index) => thisYear - index - 15
    );
    return (
        <>
            <select
                name="dateOfBirthDay"
                id="dateOfBirthDay"
                className={classNames(
                    'form-control single-select mr-1 w-25',
                    className,
                    styles.dateOfBirthSelect,
                    styles.select35Width
                )}
                onChange={onDayChange}>
                <option value={undefined} disabled selected hidden>
                    {t('registration_day')}
                </option>
                {days.map((day) => (
                    <option key={day} value={day}>
                        {day}
                    </option>
                ))}
            </select>
            <select
                name="dateOfBirthMonth"
                id="dateOfBirthMonth"
                className={classNames(
                    'form-control single-select mr-1 text-capitalize',
                    className,
                    styles.dateOfBirthSelect
                )}
                onChange={onMonthChange}>
                <option value={undefined} disabled selected hidden>
                    {t('registration_month')}
                </option>
                {months.map((month) => (
                    <option key={month} value={month}>
                        {dayjs([1970, month, 1].join('-'))
                            .toDate()
                            .toLocaleString(lang, {
                                month: 'long'
                            })}
                    </option>
                ))}
            </select>
            <select
                name="dateOfBirthYear"
                id="dateOfBirthYear"
                className={classNames(
                    'form-control single-select w-25',
                    className,
                    styles.dateOfBirthSelect,
                    styles.select35Width
                )}
                onChange={onYearChange}>
                <option value={undefined} disabled selected hidden>
                    {t('registration_year')}
                </option>
                {years.map((year) => (
                    <option key={year} value={year}>
                        {year}
                    </option>
                ))}
            </select>
        </>
    );
};
